import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Movie } from '@usheru-hff/shared/domain';
import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';
import { ChannelService } from '@usheru-hff/sdk/channel';
import { faFilm } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SearchItemType } from '@usheru-hff/shared/domain';

@Component({
  selector: 'movie-suggestion-item',
  standalone: true,
  imports: [CommonModule, SharedUtilsImageModule, FontAwesomeModule],
  styleUrl: './movie-suggestion-item.component.scss',
  template: `
    <div class="movie__poster">
      <ng-container *ngIf="movie.portraitPhotoUrl || movie.portraitPhoto; else movieImgPlaceholder">
        <img [ngSrc]="portraitPhotoUrl" height="150" width="100" [alt]="movie.title" />
      </ng-container>
    </div>
    <div class="movie__info">
      <h3 class="movie__title">{{ movie.title }}</h3>
      <p class="movie__year">{{ releaseYear }}</p>
    </div>
    <ng-template #movieImgPlaceholder>
      <fa-icon [icon]="filmIcon" size="xl"></fa-icon>
    </ng-template>
  `
})
export class MovieSuggestionItemComponent {
  private readonly channelService = inject(ChannelService);

  @Input({ required: true }) item!: SearchItemType;

  defautlImageUrl = this.channelService.getDefaultImg('portrait');
  filmIcon = faFilm;

  get releaseYear() {
    const length = this.movie.releaseDate?.length;
    if (!length) {
      return '';
    }
    return this.movie.releaseDate.slice(length - 4, length);
  }

  get movie(): Movie {
    return this.item as Movie;
  }

  get portraitPhotoUrl() {
    return this.movie.portraitPhotoUrl || this.movie.portraitPhoto || this.defautlImageUrl;
  }
}
